import PayNowFooter from 'components/Footer/PayNowFooter'

interface TabFooterProps {
  emptyOrder: boolean
  isTableDisable: boolean
  remainingAmount: number | null
  isItemSelected: boolean
}

const YourTabFooter = ({
  emptyOrder,
  isTableDisable,
  remainingAmount,
  isItemSelected,
}: TabFooterProps) => {
  // When empty order or table disabled, don't render footer
  // MenuTab component handles navigation buttons
  if (emptyOrder || isTableDisable) {
    return null
  }

  return (
    <PayNowFooter
      remainingAmount={remainingAmount}
      isItemSelected={isItemSelected}
    />
  )
}

export default YourTabFooter
